<template>
  <Container>
    <div slot="auth-container"
         class="auth-c-wrapper">
      <div>
        <img width="60"
             src="../../assets/img/enterprise/success.png" />
      </div>
      <p class="tit1">认证申请提交成功！</p>
      <p class="tit2">请耐心等待，稍后将有工作人员与您联系</p>
      <a-button style="width: 140px"
                @click="backLogin">返回登录页面</a-button>
    </div>
  </Container>
</template>

<script>
import Container from './components/container.vue'

export default {
  name: 'Authsuccess',
  components: {
    Container,
  },
  methods: {
    backLogin() {
      this.$router.push('/login')
    },
  },
}
</script>

<style lang="less" scoped>
.auth-c-wrapper {
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  .tit1 {
    font-size: 20px;
    font-weight: 500;
    color: #171717;
    margin: 16px 0 6px 0;
  }
  .tit2 {
    font-size: 14px;
    color: #606266;
    margin: 6px 0 24px 0;
  }
}
</style>